// extracted by mini-css-extract-plugin
module.exports = {"text":"text__15R2A","warningBox":"warningBox__glAWl","warning":"warning__3PdFR"};